import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { BULK_UPDATE_PRODUCTS } from '../configurations/configApi';
import { apiPost } from '../apiActions/action';
import { Modal, Backdrop, CircularProgress } from '@material-ui/core/';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles(theme => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: '1px solid #eee',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    maxWidth: '1200px',
    position: 'relative',
    borderRadius: 5
  },
  center: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  label: {
    textAlign: 'right',
    width: '70px',
    marginTop: '.5rem',
    marginRight: '0.5rem'
  },
  loading: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: -16,
    marginLeft: -32,
    borderradius: 5,
    backgroundColor: 'white',
    opacity: 0.5,
    zIndex: 999
  }
}));

const BulkUpdatePriceModal = ({ productIds, handleClose }) => {
  const classes = useStyles();
  const [newPrice, setNewPrice] = useState();
  const [loading, setLoading] = useState(false);

  const handleUpdate = () => {
    if (!newPrice) {
      return;
    }
    if (!productIds) {
      handleClose(false);
    }
    setLoading(true);
    apiPost(
      BULK_UPDATE_PRODUCTS,
      {
        product_ids: productIds,
        retail_price: parseFloat(newPrice)
      },
      ({ status, response }) => {
        setLoading(false);
        handleClose(status);
      }
    );
  };

  return (
    <>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={true}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500
        }}
      >
        <div className={classes.paper}>
          {loading && (
            <div className={classes.loading}>
              <CircularProgress color="inherit" size={20} />
            </div>
          )}
          <div className={`${classes.center} input-group mb-2`}>
            <label for="newPrice" className={classes.label}>
              New Price:
            </label>
            <div className="input-group-prepend">
              <span className="input-group-text">$</span>
            </div>
            <input
              type="number"
              step="0.01"
              className="form-control text-right"
              name="newPrice"
              id="newPrice"
              value={newPrice}
              onChange={e => setNewPrice(e.target.value)}
            />
            <br />
          </div>
          <div className="d-flex justify-content-end">
            <Button className="mr-2" onClick={() => handleClose()}>
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={handleUpdate}
            >
              Update
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default BulkUpdatePriceModal;
